import { Search, X } from "lucide-react";

export const TYPE_GROUPS = {
  pdf: { label: "PDF", ext: ["pdf"] },
  excel: { label: "Excel / CSV", ext: ["xlsx", "xlsm", "xls", "csv"] },
  word: { label: "Word / tekst", ext: ["docx", "doc", "txt", "md"] },
  image: { label: "Afbeelding", ext: ["png", "jpg", "jpeg"] },
  other: { label: "Overig", ext: ["zip"] },
};
const extOf = (name) => (name || "").split(".").pop().toLowerCase();
export const typeGroupOf = (filename) =>
  Object.keys(TYPE_GROUPS).find((k) => TYPE_GROUPS[k].ext.includes(extOf(filename))) || "other";

// Past zoektekst (naam + label) en filters (type, uploader, bron) toe op een documentenlijst.
export function filterDocuments(docs, { q, type, uploader, source }) {
  const needle = (q || "").trim().toLowerCase();
  return docs.filter((d) =>
    (!needle || `${d.filename} ${d.label || ""}`.toLowerCase().includes(needle)) &&
    (type === "all" || typeGroupOf(d.filename) === type) &&
    (uploader === "all" || d.uploaded_by === uploader) &&
    (source === "all" || d.source === source));
}

const sel = "border-2 border-foreground bg-background px-2 py-1.5 text-xs font-display uppercase tracking-wider";

// Zoekveld + filters boven de twee mappen.
export default function DocumentFilterBar({ filters, setFilters, uploaders, shown, total }) {
  const active = filters.q || filters.type !== "all" || filters.uploader !== "all" || filters.source !== "all";
  const reset = () => setFilters({ q: "", type: "all", uploader: "all", source: "all" });
  return (
    <div className="border-2 border-foreground bg-card p-3 flex flex-wrap items-center gap-2" data-testid="doc-filter-bar">
      <label className="relative flex-1 min-w-[220px]">
        <Search className="w-4 h-4 absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <input value={filters.q} onChange={(e) => setFilters({ ...filters, q: e.target.value })} placeholder="Zoek op bestandsnaam of label…"
          data-testid="doc-search" className="w-full border-2 border-foreground bg-background pl-8 pr-2 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary" />
      </label>
      <select value={filters.type} onChange={(e) => setFilters({ ...filters, type: e.target.value })} data-testid="doc-filter-type" className={sel} aria-label="Type">
        <option value="all">Alle typen</option>
        {Object.entries(TYPE_GROUPS).map(([k, g]) => <option key={k} value={k}>{g.label}</option>)}
      </select>
      <select value={filters.uploader} onChange={(e) => setFilters({ ...filters, uploader: e.target.value })} data-testid="doc-filter-uploader" className={sel} aria-label="Geüpload door">
        <option value="all">Iedereen</option>
        {uploaders.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
      </select>
      <select value={filters.source} onChange={(e) => setFilters({ ...filters, source: e.target.value })} data-testid="doc-filter-source" className={sel} aria-label="Bron">
        <option value="all">Handmatig + import</option>
        <option value="manual">Alleen handmatig</option>
        <option value="import">Alleen import</option>
      </select>
      <span className="text-[11px] text-muted-foreground font-mono-num ml-auto" data-testid="doc-filter-count">{shown} / {total} bestanden</span>
      {active && (
        <button type="button" onClick={reset} data-testid="doc-filter-reset" className="inline-flex items-center gap-1 text-[11px] font-bold underline underline-offset-2 hover:text-primary">
          <X className="w-3 h-3" /> Wis filters
        </button>
      )}
    </div>
  );
}
